import { computed } from "vue";
import { useFinder } from "#ce/composables/useFinder";
import { useHostElement } from "#ce/composables/useHostElement";
import { resolveFinder } from "#ce/shared/finder-association";

/**
 * Returns the enclosing finder's completed view and a command for selecting a view.
 * Outside a finder, `view` is undefined and `report` sends nothing.
 */
export function useFinderViewCommand() {
  const host = useHostElement();
  const finder = useFinder();

  function report(value) {
    const element = host ? resolveFinder(host).element : undefined;

    if (typeof element?.selectView === "function") {
      element.selectView(value);
    }
  }

  return { view: computed(() => finder.completed.value?.view), report };
}
